<template>
  <modal name="yagiprime-payment-dialog" :adaptive="true" :scrollable="true" height="auto"
    class="yagiprime-payment-dialog-modal">
    <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading">
      <el-button @click="closePaymentDialog" icon="el-icon-circle-close-outline" style="font-size: 2rem; padding: 0;"
        type="text"></el-button>
    </div>

    <!--ポップアップ-->
    <div class="setting" v-if="permissionType == 1">
      <div class="prime-popup">
        <h2 class="p-h2">ヤギプライム</h2>
        <div class="prime-popup-title">
          <!-- #0f9934 -->
          <h2 class="p-h2 prime-popup-title-text">プランを選択</h2>
        </div>
        <div class="flex plan-cards-container">
          <div v-if="false" class="rounded-plan-card rounded-plan-card--free">
            <p class="rounded-plan-card-title">一般会員</p>
            <p class="rounded-plan-card-price">無料</p>
          </div>
          <div @click="selectCard(1)" :class="[
            'rounded-plan-card',
            { 'rounded-plan-card--selected': selectedIndex === 1 }
          ]">
            <p class="rounded-plan-card-title">ヤギプライム</p>
            <p class="rounded-plan-card-price">標準</p>
            <p class="rounded-plan-tips-text">30日毎更新</p>
          </div>
          <div @click="selectCard(2)" v-if="false" :class="[
            'rounded-plan-card',
            { 'rounded-plan-card--selected': selectedIndex === 2 }
          ]">
            <p class="rounded-plan-card-title">ヤギプライム</p>
            <p class="rounded-plan-card-price">標準</p>
            <p class="rounded-plan-tips-text">90日毎更新</p>
          </div>
          <div @click="selectCard(3)" :class="[
            'rounded-plan-card',
            { 'rounded-plan-card--selected': selectedIndex === 3 }
          ]">
            <p class="rounded-plan-card-title">ヤギプライム</p>
            <p class="rounded-plan-card-price">就活応援</p>
            <p class="rounded-plan-tips-text">機能が増える</p>
          </div>
        </div>
        <p class="atention">Yagishの<a href="/terms" id="footer-link-terms" target="_blank">利用規約</a>、<a href="/privacy"
            id="footer-link-terms" target="_blank">個人情報の取り扱いについて</a>、<img
            src="/static/renew3_img/carat_img/caratcheck_icon.svg" alt="チェック" class="check_icon" style="">
          <a href="/yagiprimeterms" target="_blank">ヤギプライム利用規約</a>に同意の上、ヤギプライムにご登録ください。
        </p>
        <p class="price-text"><span v-if="selectedIndex === 2" class="discount-text">18%割引<br></span><span class="price-text--num">{{ price }}</span>円/{{ dates }}日</p>

        <!--配信設定-->
        <div class="notification-settings-wrapper">
          <h2 class="p-h2 prime-popup-title-text">通知設定</h2>
          <p class="atention">ヤギプライム内のサービスであるAIによる求人レコメンドのメール配信やそのほかお客様へおすすめする情報をお送りします。</p>
          <ul class="flex notification-settings">
            <li class="notification-settings__item">
              <input type="radio" id="notification-on-dialog" name="notification-dialog" value="on" v-model="notificationSetting" class="ns-input">
              <label for="notification-on-dialog" class="ns-label">受信する<span>（推奨）</span></label>
            </li>
            <li class="notification-settings__item">
              <input type="radio" id="notification-off-dialog" name="notification-dialog" value="off" v-model="notificationSetting" class="ns-input">
              <label for="notification-off-dialog" class="ns-label">受信しない</label>
            </li>
          </ul>
        </div>

        <h2 class="p-h2 prime-popup-title-text">お支払い方法</h2>
        <PaymentForm :serviceName="serviceName" :price="price" :is_subscription="true" :selectedIndex="selectedIndex" :notificationSetting="notificationSetting" />
      </div>
    </div>
    <div class="text-right">
      <el-button @click="closePaymentDialog">閉じる</el-button>
    </div>

    <CreateFormatDialog ref="createFormatDialog" />
  </modal>

</template>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.prime-btnblock {
  text-align: center;
}

.prime-btn {
  display: block;
  color: #fff;
  font-size: 1rem;
  font-weight: bold;
  background: #004d40;
  width: 250px;
  margin: 0 auto;
  border-radius: 50px;
  padding: 10px 0;
}

.prime-popup {
  .atention {
    margin: 15px 0;
  }

  .check_icon {
    position: relative;
    height: 16px;
    top: -5px;
  }

  .p-h2 {
    font-size: 16px;
    line-height: 1.4;
    margin-bottom: 10px;
  }

  .prime-popup-title-text {
    color: #0f9934;
  }

  .p-h3 {
    margin-top: 20px;
    margin-bottom: 10px;
    border: none;
  }

  .pc-list {
    background: #edf5e8;
    border-radius: 5px;
    padding: 15px 20px;
    margin-left: 0;
    margin-bottom: 15px;
  }

  .pc-item {
    justify-content: space-between;
    align-items: flex-end;
  }

  .item-left {
    font-weight: bold;
  }

  .item-amount {
    color: #e3165c;
    font-size: 18px;
    font-weight: 700;

    span {
      font-size: 16px;
      text-decoration: none;
    }
  }

  .item-txt {
    font-size: 12px;
  }

  .pc-attention {
    color: red;
  }

  .pc-memo:first-child {
    margin-top: 10px;
  }

  .price-text {
    text-align: center;
    padding: 30px;
    border: 1px solid #dfdfdf;
    border-radius: 12px;
    margin: 13px 0;
    font-weight: bold;
    font-size: 16px;

    &--num {
      font-size: 24px;
    }

    .discount-text {
      color: #0f9934;
    }
  }

  .plan-cards-container{
    justify-content: space-around;
  }

  .rounded-plan-card {
    cursor: pointer;
    background: #dfdfdf;
    border-radius: 14px;
    padding: 8px 5px;
    width: calc(100% / 2 - 15px);
    text-align: center;

    &--selected {
      background: #FFFFE8;
      border: 2px solid #E95B10;
      font-weight: bold;
    }

    .rounded-plan-card-title {
      font-size: 12px;
      color: #004d40;

      @include max-width(sm) {
        font-size: 8px;
      }
    }

    .rounded-plan-card-price {
      color: #004d40;
      margin-bottom: 5px;
    }

    .rounded-plan-tips-text {
      display: inline-block;
      color: #fff;
      font-size: 12px;
      font-weight: bold;
      text-align: center;
      background: #E95B10;
      border-radius: 40px;
      padding: 4px 20px;

      @include max-width(sm) {
        font-size: 10px;
        padding: 4px 10px;
      }
    }

    &--free {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      cursor: default;

      .rounded-plan-card-title {
        width: 100%;
        font-size: 12px;
      }

      .rounded-plan-card-price {
        width: 100%;
      }
    }
  }
}

.notification-settings-wrapper {
  margin: 30px 0;

  .notification-settings {
    justify-content: space-between;

    &__item {
      width: 50%;
      font-weight: bold;

      .ns-input {
        appearance: none;
        width: 15px;
        height: 15px;
        border-radius: 50%;
        border: 1px solid #dfdfdf;
        vertical-align: -3px;
        outline: none;
        background-color: #fff;

        &::before {
          display: block;
          content: "";
          width: 9px;
          height: 9px;
          border-radius: 9px;
          background-color: #E3165C;
          transform: translate(2px, 2px) scale(0);
          transform-origin: center;
          transition: all 0.3s cubic-bezier(0.25, 0.25, 0.56, 2);
        }

        &:checked::before {
          transform: translate(2px, 2px) scale(1);
        }
      }

      .ns-label {
        margin-left: 10px;
        vertical-align: middle;
        cursor: pointer;

        span {
          color: #E95B10;
        }
      }
    }
  }
}

.yagiprime-payment-dialog-modal {
  ::v-deep .v--modal {
    margin: 20px;
    width: auto !important;
    border-radius: 8px;
    padding: 20px;
    max-width: 600px;
  }
}
</style>

<script>
import PaymentForm from '../Payment/PaymentMethodSelector.vue'
import CreateFormatDialog from '../CreateFormatDialog.vue'

export default {
  name: 'YagiprimePaymentDialog',
  components: {
    PaymentForm,
    CreateFormatDialog
  },
  data() {
    return {
      permissionType: 1,
      fullscreenLoading: false,
      paymentMethodTab: 'card',
      isCampaign: false,
      trial_campaign_id: 0,
      serviceName: 'ヤギプライム',
      price: 550,
      dates: 30,
      selectedIndex: 1,
      hasRequiredFormat: true,
      notificationSetting: 'on' // デフォルトで「受信する」を選択
    }
  },
  created() {
  },
  mounted() {
    this.$eventHub.$on('open-yagiprime-payment-dialog', this.openPaymentDialog)
    this.$eventHub.$on('show-yagiprime-payment-dialog', this.openPaymentDialog)
    this.$eventHub.$on('hide-yagiprime-payment-dialog', this.closePaymentDialog)
    this.$eventHub.$on('auth_state_changed', this.authStateChanged)
    this.$eventHub.$on('popstate', this.closePaymentDialog)
    this.$eventHub.$on('loading_on', () => {
      this.fullscreenLoading = true
    })
    this.$eventHub.$on('payment_yagiprime_result', (result) => {
      this.fullscreenLoading = false
      if (result === 'error') {
        this.$message({
          message: '決済失敗しました',
          type: 'error'
        })
      } else if (result === 'success') {
        this.$message({
          message: '決済完了しました',
          type: 'success'
        })
      }
    })
    this.$eventHub.$on('loading_off', () => {
      this.fullscreenLoading = false
    })
  },
  destroyed() {
    this.$eventHub.$off('open-yagiprime-payment-dialog', this.openPaymentDialog)
    this.$eventHub.$off('show-yagiprime-payment-dialog', this.openPaymentDialog)
    this.$eventHub.$off('hide-yagiprime-payment-dialog', this.closePaymentDialog)
    this.$eventHub.$off('popstate', this.closePaymentDialog)
    this.$eventHub.$off('loading_on')
    this.$eventHub.$off('payment_yagiprime_result')
    this.$eventHub.$off('loading_off')
    this.$eventHub.$off('auth_state_changed', this.authStateChanged)
  },
  methods: {
    selectCard(index) {
      this.selectedIndex = index

      if (index === 1) {
        this.price = 550
        this.dates = 30
      } else if (index === 2) {
        this.price = "1,350"
        this.dates = 90
      } else if (index === 3) {
        this.price = 550
        this.dates = 30
      }

      if (index === 3) {
        try {
          const formData = new FormData()
          formData.append('uuid', this.$firebase.user ? this.$firebase.user.uid : '')
          formData.append('version', '2')
          formData.append('reqflg', '2')
          formData.append('email', this.$firebase.user ? this.$firebase.user.email : '')
          formData.append('site_flag', 'r')
          formData.append('device_flag', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
          formData.append('email_verified', this.$firebase.user ? this.$firebase.user.emailVerified ? '1' : '0' : '0')

          this.$axios.post(this.$varuna.endPoints.getMypageHistory, formData, { timeout: 60000 })
            .then(response => {
              const history = response.data.format_ids
              const requiredFormats = ['rirekisho_job_new', 'rirekisho_job_new_single', 'internship', 'entrysheet']
              const formatExists = requiredFormats.some(format =>
                history.some(item => item.format_id === format)
              )
              // 必要なフォーマットがない場合のみfalseに設定
              if (!formatExists) {
                this.hasRequiredFormat = false
                // フォーマット作成ダイアログを表示
                this.$refs.createFormatDialog.openDialog()
              }
            })
        } catch (error) {
          console.error('フォーマットチェックに失敗しました:', error)
          // エラー時もデフォルトでtrueのまま
        }
      }
    },
    openPaymentDialog() {
      this.$modal.show('yagiprime-payment-dialog')
      this.$eventHub.$emit('change-loading-text', 'ヤギプライム登録中...')
      this.selectCard(1)
    },
    closePaymentDialog() {
      this.$modal.hide('yagiprime-payment-dialog')
    },
    async authStateChanged() {
      const app = this
      try {
        const response = await this.$axios.get(
          this.$varuna.endPoints.isSubscribed + this.$firebase.user.uid + '/',
          null,
          { timeout: 60000 }
        )
        if (response.data.is_subscribed) {
          // app.$message({
          //   message: 'すでにヤギプライム登録中です。',
          //   type: 'success'
          // })
          app.$modal.hide('yagiprime-payment-dialog')
          app.$eventHub.$emit('yagiprime-payment-success')
        }
      } catch (error) {
        // app.$message({
        //   message: '認証状態の確認に失敗しました',
        //   type: 'error'
        // })
      } finally {
        app.fullscreenLoading = false
      }
    }
  }
}
</script>
